"use strict";

var KTSignup = function () {
    var handleAccountTypeSelect = function () {
        var select = document.getElementById('id_account_type');

        if (!select) {
            return;
        }

        // Auto-open select2 dropdown on focus for keyboard accessibility
        $(select).next('.select2-container').on('focus', '.select2-selection--single', function () {
            $(select).select2('open');
        });
    };

    return {
        init: function () {
            handleAccountTypeSelect();
        }
    };
}();

KTUtil.onDOMContentLoaded(function () {
    KTSignup.init();
});
